/**
 * @author Fernando Ruano
 * @file index.js
 * @description Recommendations Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Recommendations Container.
 * @return { Node } React Recommendations container.
 */
const RecommendationsContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name Recommendations.propTypes
 * @type { Object }
 */
RecommendationsContainer.propTypes = {};

/**
 * Default props
 */
RecommendationsContainer.defaultProps = {};

export default RecommendationsContainer;
